<div class="info-unavailable-container h-100 border-radius-5px text-center">
  <h1 class="info-not-available-header">{{ 'GENERIC.COMMON_PAGES.ORDER_UNAVAILABLE_HEADER' | translate }}</h1>
  <p>{{ 'GENERIC.COMMON_PAGES.ORDER_UNAVAILABLE_BODY_TEXT' | translate }}</p>
</div>
